<div class="modal-overlay" *ngIf="show" (click)="onBackdrop($event)">
  <div class="modal-content" role="dialog" aria-modal="true" aria-labelledby="app-modal-title">
    <div class="modal-body">
      <i *ngIf="icon" class="modal-icon fas {{ icon }}" [ngClass]="'tone-' + tone" aria-hidden="true"></i>
      <h2 id="app-modal-title">{{ title }}</h2>
      <p>{{ message }}</p>
      <ng-content></ng-content>
      <div class="modal-actions">
        <button *ngIf="secondaryLabel" type="button" class="done-button secondary" (click)="onSecondary()">
          {{ secondaryLabel }}
        </button>
        <button #primaryButton type="button" class="done-button" (click)="onClose()">
          {{ primaryLabel || ("quiz.seeMyResultsBtn" | translate) }}
        </button>
      </div>
    </div>
  </div>
</div>
